import {HttpClient} from "../../service/httpClient/HttpClient";

export class CategoryService {
    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
    }


    getCategoryList() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/fund-presentation/funds/${this.fundID}/cost-and-revenue-categories/trees`,
                this.httpClient.prepareUserAccessHeader(this.token),
            ).then(resolve).catch(reject)
        })
    }

    addNewCategory(name, parent) {

        const data = parseInt(parent) >= 0 ?
            {
                "title": name,
                "parent": {
                    "id": parent
                },
                "root": false
            }
            : {
                "title": name,
                "root": true
            }


        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `/fund-presentation/funds/${this.fundID}/cost-and-revenue-categories`,
                data,
                this.httpClient.prepareUserAccessHeader(this.token),
            ).then(resolve).catch(reject)
        })
    }

    updateCategoryInfo(title, parent, id) {

        const data = parent >= 0 ?
            {
                "title": title,
                "parent": {
                    "id": parent
                },
                "root": false
            }
            : {
                "title": title,
                "root": true
            }


        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `/fund-presentation/funds/${this.fundID}/cost-and-revenue-categories/${id}`,
                this.httpClient.prepareUserAccessHeader(this.token),
                data
            ).then(resolve).catch(reject)
        })
    }
}